import { forwardRef } from "react";

type Props = {
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export const BoardWidgetsButton = forwardRef<HTMLButtonElement, Props>(
  function BoardWidgetsButton({ active, disabled, onClick }, ref) {
    return (
      <button
        ref={ref}
        type="button"
        className={`wb-tool-icon-btn wb-tool-icon-btn--ghost${active ? " is-active" : ""}`}
        title="Виджеты"
        aria-label="Виджеты"
        aria-pressed={active}
        disabled={disabled}
        onClick={onClick}
      >
        <svg
          className="wb-tool-icon-btn__svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <rect x="3" y="3" width="7" height="7" rx="1.5" />
          <rect x="14" y="3" width="7" height="7" rx="1.5" />
          <rect x="3" y="14" width="7" height="7" rx="1.5" />
          <rect x="14" y="14" width="7" height="7" rx="1.5" />
        </svg>
      </button>
    );
  }
);
